import Rest from '../../Rest'

export default class ReportingChannelWorkflowConfigService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_handling/config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  grid(path: string = '', data: any) {
    if (path !== '') {
      return this.get(path, data)
    }
    return this.get('grid', data)
  }

  read(id: Number) {
    return this.get(`/${id}`)
  }

  create(data: any) {
    return this.post('', data)
  }

  update(data: any) {
    return this.put(`/${data.id}`, data)
  }

  destroy(id: Number) {
    return this.delete(`/${id}`)
  }
}
